






























import Vue from 'vue'
import { ModuleNames } from '@/store/module-names'
import { ActionNames as ExerciseActionNames, GetterNames as ExerciseGetterNames } from '@/store/modules/exercise/keys'
import { LoadingTypes } from '@/store/modules/exercise/types'
import ExerciseReport from '@/components/exercises/components/ExerciseReport.vue'
import ExerciseButton from '@/components/exercises/components/ExerciseButton.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { ActionNames as PatientActionNames, GetterNames as PatientGetterNames } from '@/store/modules/patient/keys'
import { FlatPatientExercise } from '@/store/modules/exercise/getters'

export default Vue.extend({
  components: {
    ExerciseReport,
    ExerciseButton,
  },
  data() {
    return {
      isInitialLoading: true as boolean,
    }
  },
  computed: {
    ...mapState(ModuleNames.exercise, ['loading']),
    ...mapGetters(ModuleNames.exercise, [ExerciseGetterNames.sortedExercises]),
    ...mapGetters(ModuleNames.patient, [PatientGetterNames.patientNameMapById]),
    currentPatientExercises(): FlatPatientExercise[] {
      return this[ExerciseGetterNames.sortedExercises].filter(ex => ex.patientId === this.patientId)
    },
    showFullScreenLoading(): boolean {
      return this.loading === LoadingTypes.FULL_SCREEN
    },
    patientId(): string {
      return this.$route.params.patient_id || ''
    },
    patientName(): string {
      return this[PatientGetterNames.patientNameMapById][this.patientId] || ''
    },
  },
  async mounted(): Promise<void> {
    await this.initComponent({ patientId: this.patientId, path: this.$route.path })
  },
  async beforeRouteUpdate(to, from, next): Promise<void> {
    await this.initComponent({ patientId: to.params.patient_id, path: to.path })
    next()
  },
  methods: {
    async initComponent({ patientId, path }): Promise<void> {
      this.isInitialLoading = true
      await this[PatientActionNames.getPatient]({ patientId: patientId })

      const patientName = this[PatientGetterNames.patientNameMapById][patientId]
      if (!patientName) {
        await this.$router.replace({ name: '404', params: { '0': path } })
        return
      }
      await this[ExerciseActionNames.getExercisesByPatient](patientId)
      this.isInitialLoading = false
    },
    ...mapActions(ModuleNames.patient, [PatientActionNames.getPatient]),
    ...mapActions(ModuleNames.exercise, [ExerciseActionNames.postExercise, ExerciseActionNames.getExercisesByPatient]),
    async postExercise(patientId): Promise<void> {
      const newExerciseId = await this[ExerciseActionNames.postExercise]({ patientId })
      this.$router.push({ name: 'exercises-detail', params: { exercise_id: newExerciseId }, query: { edit: '' } })
    },
  },
})
